import { defined } from '@vy/null';
import { Optional } from '@vy/object';
import { EmptyArray, NonEmptyArray } from '../types';

export function isEmpty<Item>(array: Optional<Item[]>): array is Optional<EmptyArray> {
  return !defined(array) || array.length === 0;
}

export function isNotEmpty<Item>(array: Optional<Item[]>): array is NonEmptyArray<Item> {
  return defined(array) && array.length > 0;
}

export function containsManyItems<Item>(array: Optional<Item[]>): array is [Item, Item, ...Item[]] {
  return defined(array) && array.length > 1;
}

export function isSingleItem<Item>(array: Optional<Item[]>): array is [Item] {
  return defined(array) && array.length === 1;
}

export function isArray<Item>(array: Item[] | unknown): array is Item[] {
  return Array.isArray(array);
}

export function isNotIn<Item>(array: Optional<Item[]>, ...items: Item[]) {
  return isEmpty(array) || array.every((item) => !items.includes(item));
}
